<script>
  import NewLeadsBalkenElement from "./NewLeadsBalkenElement.svelte";
  import NewClientsBalkenElement from "./NewClientsBalkenElement.svelte";
  import { dict_to_sum, get_vorgaenger_active_animals, max_of_dict } from "./UtilsBalkenProgress.svelte";
  import { afterUpdate } from "svelte";
  import NewActiveBoliBalkenElement from "./NewActiveBoliBalkenElement.svelte";
  import Deactivated from "./Deactivated.svelte";
  import DeactivatedActiveBoli from "./DeactivatedActiveBoli.svelte";

  import { all_sources, find_help_text_if_exists, source_text } from "./Utils.svelte";

  import jQuery from "jquery";

  window.jQuery = jQuery;
  window.$ = jQuery;

  export let source_cat_dict;
  export let table_leads_dict;
  export let table_clients_dict;
  export let table_lost_clients_dict;
  export let table_sold_boli_dict;
  export let table_active_boli_dict;
  export let table_lost_boli_dict;
  export let table_leads_basis;
  export let table_opps_dict;
  export let table_opps_basis;
  export let table_clients_basis;
  export let table_sold_boli_basis;
  export let table_active_boli_basis;
  export let table_active_boli_deactivated_animals;
  export let table_active_boli_new_boli_new_customers;
  export let selected_timeframe_text;

  export let helptexts;
  export let in_show_helptext_id;

  let refresh_margin_table = false;

  export let months = ["01/22", "02/22", "03/22", "04/22", "05/22", "06/22", "07/22", "08/22", "09/22", "10/22", "11/22", "12/22"];

  refresh_margin_table;
  afterUpdate(() => {
    refresh_margin_table = true;
    refresh_margin_table = false;
  });

  function month_format(month) {
    var split = month.split("-");
    return split[1] + "/" + split[0].substring(2, 4);
  }

  function get_vorgaenger(dict, index, basis, lost_dict = false) {
    if (index == 0) {
      return basis;
    }

    var a = basis;

    for (var i = 0; i < index; i = i + 1) {
      a += dict[months[i]];
      if (lost_dict) {
        a -= lost_dict[months[i]];
      }
    }

    // if(index == 12){
    //   console.log("INDEX IST 12: ")
    //   console.log("dict: ", dict)
    //   console.log("a: ", a)
    //  console.log("basis: ", basis)
    //  console.log("months: ", months)
    // }

    return a;
  }

  function calc_margin() {
    // var full_width = window.$(window).width();
    // var card_width = window.$('#card-body-balken-table-marketing').outerWidth();
    // var basis_width = window.$('#basis').outerWidth();

    // var used_width = card_width;
    // if (card_width == 0) {
    //   used_width = full_width;
    // }

    // console.log('used_width: ', used_width);
    // console.log("basis_width: ", basis_width)

    // return (used_width * 1.6) / 100;

    return 5;
  }

  function get_width_percentage(months) {
    if (months.length < 12) {
      return 80 / 14;
    }

    return 80 / (months.length + 2);
  }
</script>

<div class="card h-100" style="width: {months.length > 12 ? 150 : 100}%;">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="card-title mb-0">Marketing progress report {selected_timeframe_text}</h5>
    <div class="info-circle my-auto">
      <div class="my-auto info-i">i</div>
      <div class="info-box" style="color: #000000;">
        {#if find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_1")}
          {@html find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_1")}
        {:else}
          <p>
            The <strong>marketing progress report</strong> shows for the reporting timeframe (per month and in total for the whole timeframe)
            the number of:
          </p>
          <ul>
            <li>
              <strong>new leads</strong> (&ldquo;Basis&rdquo; = median of the number of new leads per month of all months of the year prior to
              the reporting timeframe)
            </li>
            <li>
              <strong>new opportunities</strong> (&ldquo;Basis&rdquo; = median of the number of new opportunities per month of all months of
              the year prior to the reporting timeframe)
            </li>
            <li>
              <strong>active, won and lost customers</strong> (&ldquo;Basis&rdquo; = number of customers one day before the start of the reporting
              timeframe)
            </li>
            <li>
              <strong>Sold BOLUSES</strong> (&ldquo;Basis&rdquo; = median of the number of Sold BOLUSES per month of all months of the year prior
              to the reporting timeframe)
            </li>
          </ul>
          <p>The last chart shows how the number of active boluses has evolved from month to month, providing information on:</p>
          <ul>
            <li>
              the number of active boluses at the beginning of the timeframe (= end of month prior to the reporting timeframe; =
              &ldquo;Basis&rdquo;)
            </li>
            <li>the number of active boluses at the end of each month</li>
            <li><span style="color: #AFCB08;">New</span>: new boluses of new customers per month</li>
            <li><span style="color: #AFC5B9;">Increase</span>: boluses increase per month (excluding new boluses of new customers)</li>
            <li><span style="color: #AFC5B9;">Decrease</span>: deactivated boluses per month (excluding churn boluses)</li>
            <li><span style="color: #FFC000;">Churn</span>: deactivated boluses of churn customers (=churn boluses) per month.</li>
          </ul>
          <p>
            <br /><strong>New bolus of new customer</strong> = a bolus that has been activated within a period of 6 month after the month of
            the contract signature of a customer.<br /><strong>Churn customer</strong> = A customer who cancelled his subscription during the
            reporting timeframe.
          </p>
          <p>
            <br /><span style="color: #808080;">Please note</span><br /><span style="color: #808080;"
              ><strong>Selection of lead countries</strong>:</span
            ><br /><span style="color: #808080;"
              >All information in the marketing progress report relates to the countries selected under &ldquo;Select lead countries&rdquo;.
              This means that the leads, opportunities, customers, and Sold BOLUSES in these countries form the basis of the charts in this
              report.</span
            >
          </p>
          <p>
            <span style="color: #808080;"><strong>Selection of source categories</strong>:</span><br /><span style="color: #808080;"
              >The source category selection only affects the &ldquo;New Leads&rdquo; chart and the &ldquo;New opportunities&rdquo; chart.
              The other charts (&ldquo;Active CUSTOMERS&rdquo;, &ldquo;Sold BOLUSES&rdquo;, &ldquo;Active BOLUSES&rdquo;) are not affected
              by the source category selection.</span
            >
          </p>
          <p>
            <span style="color: #808080;"><strong>Handling of leads based on data imports</strong>:</span><br /><span
              style="color: #808080;"
              >Leads from the sales source category "data import" are only counted as &rdquo;new lead" if an opportunity is created based on
              the lead. In this case, the lead creation date is the same as the opportunity creation date.</span
            >
          </p>
        {/if}
        {#if in_show_helptext_id}
          <div style="font-size: 7px">id: sales_mirror_balken_progress_1</div>
          <div style="font-size: 7px">
            [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="card-body">
    <table style="width:100%;">
      <colgroup>
        <col span="1" style="width: {months.length > 12 ? 5 : 10}%;" />
        <col span="1" style="width: {months.length > 12 ? 5 : 10}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />

        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />
        <col span="1" style="width: {get_width_percentage(months)}%;" />

        <col span="1" style="width: {get_width_percentage(months)}%;" />
      </colgroup>

      <tr>
        <th />
        <th style="min-width:100px;" />
        <th id="basis" style="text-align: center;">
          <div
            style="
            margin-left: 12px; margin-right: 12px;
                background-color: #d7e2dc; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
          >
            <span>Basis</span>
          </div>
        </th>

        {#each months as monats_label, index}
          <th style="text-align: center; ">
            <div
              style="margin-left: {calc_margin(monats_label, refresh_margin_table)}px; margin-right: {calc_margin(
                monats_label,
                refresh_margin_table,
              )}px; background-color: #f2f2f2; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
            >
              <span>{month_format(monats_label)}</span>
            </div>
          </th>
        {/each}

        <th style="text-align: center;  ">
          <div
            style="
            margin-left: 12px; margin-right: 12px;
                background-color: #d7e2dc; padding-left:12px;padding-right:12px;padding-top:5px;padding-bottom:5px;"
          >
            <span>Total</span>
          </div>
        </th>
      </tr>

      <!-- NEW LEADS -->

      <!-- leere Zeile -->
      <tr style="border-bottom: 0.25pt solid #d9d9d9;">
        {#each months as monats_label, index}
          {#if index == 0}
            <td style="border-bottom: 0.25pt solid #51c3f9;">&nbsp;</td>
            <td />
          {:else}
            <td>&nbsp;</td>
          {/if}
        {/each}
      </tr>

      <tr style="">
        <td style="padding-top:0px; ">
          <div
            style="font-size: .9rem; background-color: #51c3f9; color: #FFFFFF; padding-left:12px;padding-right:12px;padding-top:0px;padding-bottom:5px;"
          >
            New LEADS
          </div>
          <div style="font-size:10px; color:{all_sources(source_cat_dict) ? '#51c3f9' : '#455F51'}">{source_text(source_cat_dict)}</div>
        </td>
        {#each months as monats_label, index}
          {#if index != 0}
            <td />
            <td />
          {/if}
        {/each}
      </tr>

      <tr style="vertical-align: bottom; border-bottom: 0.25pt solid #d9d9d9;">
        <td style="border-bottom:3px solid white; padding:0px;" />
        <td />
        {#if months.length > 0}
          <td style="vertical-align: bottom; padding:0px;">
            <NewLeadsBalkenElement
              is_basis_balken={true}
              vorgaenger_box_color={"#d9d9d9"}
              max_value={max_of_dict(table_leads_dict)}
              value={table_leads_basis}
              background_color_mitte={"#FFFFFF"}
              border_color_mitte={"#FFFFFF"}
              background_color_bottom={"#d9d9d9"}
            />
          </td>
        {/if}
        {#each months as monats_label, index}
          <td style="vertical-align: bottom; padding:0px;">
            <NewLeadsBalkenElement max_value={max_of_dict(table_leads_dict)} value={table_leads_dict[monats_label]} />
          </td>
        {/each}

        <td class="hoverclass" style="vertical-align: bottom; padding:0px;">
          {#if table_leads_dict}
            <NewLeadsBalkenElement
              total_text={"New"}
              is_total={true}
              max_value={dict_to_sum(table_leads_dict)}
              value={dict_to_sum(table_leads_dict)}
            />
            <div class="info-box-auf-hoehe">
              {#if find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_2")}
                {@html find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_2")}
              {:else}
                <p><strong>New leads</strong> &hellip; Total number of leads created during reporting timeframe.</p>
                <p>
                  Please note: Leads from the <strong>sales source category "data import"</strong> are only counted as &rdquo;new lead" if an
                  opportunity is created based on the lead. In this case, the lead creation date is the same as the opportunity creation date.
                </p>
              {/if}
              {#if in_show_helptext_id}
                <div style="font-size: 7px">id: sales_mirror_balken_progress_2</div>
                <div style="font-size: 7px">
                  [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
                </div>
              {/if}
            </div>
          {/if}
        </td>
      </tr>

      <!-- NEW OPPS -->

      <!-- leere Zeile -->
      <tr style="border-bottom: 0.25pt solid #d9d9d9;">
        {#each months as monats_label, index}
          {#if index == 0}
            <td style="border-bottom: 0.25pt solid #51c3f9;">&nbsp;</td>
            <td />
          {:else}
            <td>&nbsp;</td>
          {/if}
        {/each}
      </tr>

      <tr style="">
        <td style="padding-top:0px; ">
          <div
            style="font-size: .9rem; background-color: #44C1A3; color: #FFFFFF; padding-left:12px;padding-right:12px;padding-top:0px;padding-bottom:5px;"
          >
            New OPPs
          </div>
          <div style="font-size:10px; color:{all_sources(source_cat_dict) ? '#44C1A3' : '#455F51'}">{source_text(source_cat_dict)}</div>
        </td>
        {#each months as monats_label, index}
          {#if index != 0}
            <td />
            <td />
          {/if}
        {/each}
      </tr>

      <tr style="vertical-align: bottom; border-bottom: 0.25pt solid #d9d9d9;">
        <td style="border-bottom:3px solid white; padding:0px;" />
        <td />
        {#if months.length > 0}
          <td style="vertical-align: bottom; padding:0px;">
            <NewLeadsBalkenElement
              is_basis_balken={true}
              vorgaenger_box_color={"#d9d9d9"}
              max_value={max_of_dict(table_opps_dict)}
              value={table_opps_basis}
              background_color_mitte={"#FFFFFF"}
              border_color_mitte={"#FFFFFF"}
              background_color_bottom={"#d9d9d9"}
            />
          </td>
        {/if}
        {#each months as monats_label, index}
          <td style="vertical-align: bottom; padding:0px;">
            <NewLeadsBalkenElement max_value={max_of_dict(table_opps_dict)} value={table_opps_dict[monats_label]} />
          </td>
        {/each}

        <td class="hoverclass" style="vertical-align: bottom; padding:0px;">
          {#if table_opps_dict}
            <NewLeadsBalkenElement
              total_text={"New"}
              is_total={true}
              max_value={dict_to_sum(table_opps_dict)}
              value={dict_to_sum(table_opps_dict)}
            />
          {/if}
          <div class="info-box-auf-hoehe">
            {#if find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_3")}
              {@html find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_3")}
            {:else}
              <p><strong>New opportunities</strong> &hellip; Total number of opportunities created during reporting timeframe.</p>
            {/if}
            {#if in_show_helptext_id}
              <div style="font-size: 7px">id: sales_mirror_balken_progress_3</div>
              <div style="font-size: 7px">
                [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
              </div>
            {/if}
          </div>
        </td>
      </tr>

      <!-- NEW CLIENTS -->

      <!-- leere Zeile -->
      <tr style="border-bottom: 0.25pt solid #d9d9d9;">
        {#each months as monats_label, index}
          {#if index == 0}
            <td style="border-bottom: 0.25pt solid #37a781;">&nbsp;</td>
            <td />
          {:else}
            <td>&nbsp;</td>
          {/if}
        {/each}
      </tr>

      <tr style="">
        <td style="padding-top:0px; ">
          <div
            style="font-size: .9rem; background-color: #37A76F; color: #FFFFFF; padding-left:10px;padding-right:10px;padding-top:0px;padding-bottom:0px;"
          >
            Active CUSTOMERS
          </div>
          <div style="font-size:10px; color:#455F51">All sources</div>
        </td>
        <td />
        {#each months as monats_label, index}
          {#if index != 0}
            <td />
          {/if}
        {/each}
      </tr>

      <tr style="vertical-align: bottom; border-bottom: 0.25pt solid #d9d9d9;">
        <td style="border-bottom:3px solid white;padding:0px;" />
        <td />
        {#if months.length > 0}
          <td style="vertical-align: bottom;padding:0px;">
            <NewClientsBalkenElement
              is_basis_balken={true}
              max_value={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis)}
              oberer_text={table_clients_basis}
              unterer_text={table_clients_basis}
              gruen={0}
              basis={table_clients_basis}
              border_color_mitte={"#FFFFFF"}
            />
          </td>
        {/if}
        {#each months as monats_label, index}
          <td style="vertical-align: bottom;padding:0px;">
            <NewClientsBalkenElement
              max_value={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis, table_lost_clients_dict)}
              oberer_text={get_vorgaenger(table_clients_dict, index, table_clients_basis, table_lost_clients_dict) +
                table_clients_dict[monats_label] -
                table_lost_clients_dict[monats_label]}
              unterer_text={table_clients_dict[monats_label]}
              gruen={table_clients_dict[monats_label]}
              basis={get_vorgaenger(table_clients_dict, index, table_clients_basis, table_lost_clients_dict)}
              deactivated_animals={table_lost_clients_dict[monats_label]}
              border_color_mitte={"#FFFFFF"}
            />
          </td>
        {/each}

        <td class="hoverclass" style="vertical-align: bottom;padding:0px;">
          {#if table_clients_dict}
            <NewClientsBalkenElement
              is_total={true}
              max_value={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis, table_lost_clients_dict)}
              oberer_text={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis, table_lost_clients_dict) +
                table_clients_dict[months[months.length - 1]] -
                table_lost_clients_dict[months[months.length - 1]]}
              unterer_text={""}
              deactivated_animals={dict_to_sum(table_lost_clients_dict)}
              gruen={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis) +
                table_clients_dict[months[months.length - 1]] -
                table_clients_basis}
              basis={table_clients_basis}
              vorgaenger_box_color={"#d9d9d9"}
              border_color_mitte={"#FFFFFF"}
              {helptexts}
              {in_show_helptext_id}
            />
          {/if}
        </td>
      </tr>

      <tr style="">
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        {#each months as monats_label, index}
          <Deactivated
            deactivated_animals={table_lost_clients_dict[monats_label]}
            max_value={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis, table_lost_clients_dict)}
            {helptexts}
            {in_show_helptext_id}
          />
        {/each}
        {#if table_lost_clients_dict && months}
          <Deactivated
            is_total={true}
            deactivated_animals={dict_to_sum(table_lost_clients_dict)}
            max_value={get_vorgaenger(table_clients_dict, months.length - 1, table_clients_basis, table_lost_clients_dict)}
            {helptexts}
            {in_show_helptext_id}
          />
        {/if}
      </tr>

      <!-- Sold BOLUSES -->

      <!-- leere Zeile -->
      <tr style="border-bottom: 0.25pt solid #d9d9d9;">
        {#each months as monats_label, index}
          {#if index == 0}
            <td style="border-bottom: 0.25pt solid #37a781;">&nbsp;</td>
            <td />
          {:else}
            <td>&nbsp;</td>
          {/if}
        {/each}
      </tr>

      <tr style="">
        <td style="padding-top:0px; ">
          <div
            style="font-size: .9rem; background-color: #63A537; color: #FFFFFF; padding-left:10px;padding-right:10px;padding-top:0px;padding-bottom:0px;"
          >
            Sold BOLUSES
          </div>
          <div style="font-size:10px; color:#455F51">All sources</div>
        </td>
        <td />
        {#each months as monats_label, index}
          {#if index != 0}
            <td />
          {/if}
        {/each}
      </tr>

      <tr style="vertical-align: bottom; border-bottom: 0.25pt solid #d9d9d9;">
        <td style="border-bottom:3px solid white;padding:0px;" />
        <td />
        {#if months.length > 0}
          <td style="vertical-align: bottom; padding:0px;">
            <NewLeadsBalkenElement
              is_basis_balken={true}
              vorgaenger_box_color={"#d9d9d9"}
              max_value={max_of_dict(table_sold_boli_dict)}
              value={table_sold_boli_basis}
              background_color_mitte={"#FFFFFF"}
              border_color_mitte={"#FFFFFF"}
              background_color_bottom={"#d9d9d9"}
              {helptexts}
              {in_show_helptext_id}
            />
          </td>
        {/if}
        {#each months as monats_label, index}
          <td style="vertical-align: bottom;padding:0px;">
            <NewLeadsBalkenElement
              max_value={max_of_dict(table_sold_boli_dict)}
              value={table_sold_boli_dict[monats_label]}
              {helptexts}
              {in_show_helptext_id}
            />
          </td>
        {/each}
        <td class="hoverclass" style="vertical-align: bottom;padding:0px;">
          {#if table_sold_boli_dict}
            <NewLeadsBalkenElement
              total_text={"Sold"}
              is_total={true}
              max_value={dict_to_sum(table_sold_boli_dict)}
              value={dict_to_sum(table_sold_boli_dict)}
              {helptexts}
              {in_show_helptext_id}
            />
          {/if}
          <div class="info-box-auf-hoehe">
            {#if find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_4")}
              {@html find_help_text_if_exists(helptexts, "sales_mirror_balken_progress_4")}
            {:else}
              <p><strong>Sold BOLUSES</strong> &hellip; Total number of boluses sold during the reporting timeframe</p>
            {/if}
            {#if in_show_helptext_id}
              <div style="font-size: 7px">id: sales_mirror_balken_progress_4</div>
              <div style="font-size: 7px">
                [this is only shown to users with the "show_helptext_id permission (per default: Ghais, Astrid, Stefan B)]
              </div>
            {/if}
          </div>
        </td>
      </tr>

      <!-- ACTIVE BOLI -->

      <!-- leere Zeile -->
      <tr style="border-bottom: 0.25pt solid #d9d9d9;">
        {#each months as monats_label, index}
          {#if index == 0}
            <td style="border-bottom: 0.25pt solid #37a781;">&nbsp;</td>
            <td />
          {:else}
            <td>&nbsp;</td>
          {/if}
        {/each}
      </tr>

      <tr style="">
        <td style="padding-top:0px; ">
          <div
            style="font-size: .9rem; background-color: #AFCB08; color: #FFFFFF; padding-left:10px;padding-right:10px;padding-top:0px;padding-bottom:0px;"
          >
            Active BOLUSES
          </div>
          <div style="font-size:10px; color:#455F51">All sources</div>
        </td>
        <td />
        {#each months as monats_label, index}
          {#if index != 0}
            <td />
          {/if}
        {/each}
        <td />
        <td />
        <td />
      </tr>

      <tr style=" vertical-align: bottom; border-bottom: 0.25pt solid #d9d9d9;">
        <td style="border-bottom:3px solid white;padding:0px;" />
        <td />
        {#if months.length > 0}
          <td style="vertical-align: bottom;padding:0px;">
            <NewActiveBoliBalkenElement
              is_basis_balken={true}
              max_value={table_active_boli_basis +
                dict_to_sum(table_active_boli_dict) +
                dict_to_sum(table_active_boli_new_boli_new_customers) -
                dict_to_sum(table_active_boli_deactivated_animals) -
                dict_to_sum(table_lost_boli_dict)}
              oberer_text={table_active_boli_basis}
              unterer_text={table_active_boli_basis}
              gruen={0}
              basis={table_active_boli_basis}
              {helptexts}
              {in_show_helptext_id}
            />
          </td>
        {/if}
        {#each months as monats_label, index}
          <td style="vertical-align: bottom;padding:0px;">
            <NewActiveBoliBalkenElement
              max_value={table_active_boli_basis +
                dict_to_sum(table_active_boli_dict) +
                dict_to_sum(table_active_boli_new_boli_new_customers) -
                dict_to_sum(table_active_boli_deactivated_animals) -
                dict_to_sum(table_lost_boli_dict)}
              oberer_text={get_vorgaenger_active_animals(
                months,
                table_active_boli_dict,
                index,
                table_active_boli_basis,
                false,
                table_active_boli_deactivated_animals,
                table_active_boli_new_boli_new_customers,
                table_lost_boli_dict,
              ) +
                table_active_boli_dict[monats_label] +
                table_active_boli_new_boli_new_customers[monats_label] -
                table_active_boli_deactivated_animals[monats_label] -
                table_lost_boli_dict[monats_label]}
              unterer_text={table_active_boli_dict[monats_label]}
              gruen={table_active_boli_dict[monats_label]}
              gruen_davon_new_cust={table_active_boli_new_boli_new_customers[monats_label]}
              basis={get_vorgaenger_active_animals(
                months,
                table_active_boli_dict,
                index,
                table_active_boli_basis,
                false,
                table_active_boli_deactivated_animals,
                table_active_boli_new_boli_new_customers,
                table_lost_boli_dict,
              )}
              deactivated_animals={table_lost_boli_dict[monats_label]}
              deactivated_animals_from_animals_table={table_active_boli_deactivated_animals[monats_label] -
                table_lost_boli_dict[monats_label]}
              {helptexts}
              {in_show_helptext_id}
            />
          </td>
        {/each}
        <td style="vertical-align: bottom;padding:0px;">
          {#if table_active_boli_dict}
            <NewActiveBoliBalkenElement
              is_total={true}
              max_value={table_active_boli_basis +
                dict_to_sum(table_active_boli_dict) +
                dict_to_sum(table_active_boli_new_boli_new_customers) -
                dict_to_sum(table_active_boli_deactivated_animals) -
                dict_to_sum(table_lost_boli_dict)}
              oberer_text={table_active_boli_basis +
                dict_to_sum(table_active_boli_dict) +
                dict_to_sum(table_active_boli_new_boli_new_customers) -
                dict_to_sum(table_active_boli_deactivated_animals) -
                dict_to_sum(table_lost_boli_dict)}
              unterer_text={""}
              deactivated_animals={dict_to_sum(table_lost_boli_dict)}
              deactivated_animals_from_animals_table={dict_to_sum(table_active_boli_deactivated_animals)}
              gruen={dict_to_sum(table_active_boli_dict)}
              gruen_davon_new_cust={dict_to_sum(table_active_boli_new_boli_new_customers)}
              basis={table_active_boli_basis}
              vorgaenger_box_color={"#d9d9d9"}
              {helptexts}
              {in_show_helptext_id}
            />
          {/if}
        </td>
      </tr>

      <tr style="">
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        {#each months as monats_label, index}
          <DeactivatedActiveBoli
            deactivated_animals={table_lost_boli_dict[monats_label]}
            deactivated_animals_from_animals_table={table_active_boli_deactivated_animals[monats_label]}
            max_value={table_active_boli_basis +
              dict_to_sum(table_active_boli_dict) +
              dict_to_sum(table_active_boli_new_boli_new_customers) -
              dict_to_sum(table_active_boli_deactivated_animals) -
              dict_to_sum(table_lost_boli_dict)}
            {helptexts}
            {in_show_helptext_id}
          />
        {/each}
        {#if table_lost_boli_dict && months}
          <DeactivatedActiveBoli
            is_total={true}
            deactivated_animals={dict_to_sum(table_lost_boli_dict)}
            deactivated_animals_from_animals_table={dict_to_sum(table_active_boli_deactivated_animals)}
            max_value={table_active_boli_basis +
              dict_to_sum(table_active_boli_dict) +
              dict_to_sum(table_active_boli_new_boli_new_customers) -
              dict_to_sum(table_active_boli_deactivated_animals) -
              dict_to_sum(table_lost_boli_dict)}
            {helptexts}
            {in_show_helptext_id}
          />
        {/if}
      </tr>
    </table>
  </div>
</div>

<style>
  .info-box-auf-hoehe {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: auto;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: var(--y);
    left: var(--x);
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #000000;
    font-size: 12px;
    height: auto;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 50px;
    right: 50px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-box:hover .info-box {
    display: block;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .hoverclass:hover .info-box {
    display: block;
  }

  .hoverclass:hover .info-i {
    display: none;
  }

  .info-box-auf-hoehe:hover .info-box-auf-hoehe {
    display: block;
  }

  .info-circle:hover .info-box-auf-hoehe {
    display: block;
  }

  .hoverclass:hover .info-box-auf-hoehe {
    display: block;
  }
</style>
